import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  getGamAd,
  createUniqueAdId,
  destroyGamSlot,
  shouldShowAd
} from "@wattpad/client-platform-web-ads";

const GamAdContainer = ({
  placement,
  adData,
  className,
  wrapperClassName,
  adEligibility
}) => {
  const [uniquePlacement] = useState(createUniqueAdId(placement));
  let renderAd;

  try {
    renderAd = shouldShowAd(
      adEligibility,
      placement,
      adData?.testGroups,
      adData?.context
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      "error in gam ad container with eligibility:",
      adEligibility,
      error
    );
    renderAd = { result: false, reason: "error" };
  }

  const athaSkipReasons = [
    "skipped_brandsafe",
    "skipped_default",
    "mature_ad_eligibility"
  ];

  const initializeAd = () => {
    if (renderAd.result) {
      //   return;
      // todo add this back when the ads package is updated
      getGamAd({ ...adData, placement: uniquePlacement, adEligibility });
    } else {
      if (
        typeof __atha !== "undefined" &&
        (renderAd.reason.includes("skipped_special_placement_") ||
          athaSkipReasons.includes(renderAd.reason))
      ) {
        // todo: see if this is still true:
        // this would ideally live in the ads package but due to some rendering issues includeAdMarkup gets called
        // multiple times.
        // eslint-disable-next-line no-undef
        __atha.sendSkip(
          placement,
          renderAd.reason,
          adData?.context?.story,
          adData?.context?.storyPart
        );
      }
    }
  };

  const adComponent = () => {
    return <div className={className} id={uniquePlacement} />;
  };

  const ConditionalAdWrapper = () => {
    return wrapperClassName ? (
      <div className={wrapperClassName}>{adComponent()}</div>
    ) : (
      adComponent()
    );
  };

  useEffect(initializeAd, [renderAd.result]);

  // release the GPT slot when this div leaves the page
  useEffect(() => () => destroyGamSlot(uniquePlacement), [uniquePlacement]);

  // todo add this back when refresh functionality is implemented
  //   useEffect(() => {
  //     if (
  //       refresh &&
  //       typeof refreshAdFunction === "function" &&
  //       window &&
  //       window.addEventListener
  //     ) {
  //       const refreshEvent = `refresh-${placement}`;
  //       window.addEventListener(refreshEvent, refreshAdFunction);
  //       return () => {
  //         window.removeEventListener(refreshEvent, refreshAdFunction);
  //       };
  //     }
  //   });

  return renderAd.result ? ConditionalAdWrapper() : null;
};

const StoryGroupProps = {
  isAdExempt: PropTypes.bool.isRequired,
  isBrandSafe: PropTypes.bool.isRequired,
  isPaywalled: PropTypes.bool.isRequired,
  rating: PropTypes.number.isRequired,
  language: PropTypes.number
};

const StoryPartProps = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  brandSafetyLevel: PropTypes.number.isRequired,
  brandSafetySource: PropTypes.string.isRequired,
  rank: PropTypes.number, // Doesn't always exist
  rating: PropTypes.number.isRequired,
  totalViewCount: PropTypes.number.isRequired
};

const AdContextProps = {
  user: PropTypes.shape({
    isPremium: PropTypes.bool
  }),
  story: PropTypes.shape(StoryGroupProps),
  storyPart: PropTypes.shape(StoryPartProps)
};

GamAdContainer.propTypes = {
  placement: PropTypes.string.isRequired,
  adData: PropTypes.shape({
    userGeo: PropTypes.string.isRequired,
    testGroups: PropTypes.objectOf(PropTypes.bool).isRequired,
    deviceType: PropTypes.string.isRequired,
    context: PropTypes.shape(AdContextProps)
  }).isRequired,
  className: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string,
  refresh: PropTypes.bool
};

export default GamAdContainer;
